/* Swiper
 **************************************************************/
var numbersSwiper = new Swiper(".numbers-swiper", {
  slidesPerView: "auto",
  centeredSlides: false,
  loop: false,
  spaceBetween: 0,
  navigation: false,
  scrollbar: {
    el: ".numbers-swiper-scrollbar",
    draggable: true,
  },
  mousewheel: false,
  breakpoints: {},
});
